import { defineType, defineField } from 'sanity';

export default defineType({
	name:   'staticPage',
	title:  'Static Page',
	type:   'object',
	fields: [
		defineField({
			name:    'slug',
			title:   'Slug',
			type:    'slug',
			options: {
				source:    'seoTitle',
				maxLength: 96,
			},
			validation: Rule => Rule.required(),
		}),

		defineField({
			name:       'seoTitle',
			title:      'SEO Title',
			type:       'string',
			validation: Rule => Rule.required(),
		}),

		defineField({
			name:  'seoDescription',
			title: 'SEO Description',
			type:  'text',
			rows:  3,
		}),
		defineField({
			name:   'content',
			title:  'Page Content',
			type:   'object',
			fields: [
				{
					name:  'en',
					title: 'English',
					type:  'array',
					of:    [
						{ type: 'block' },
						{
							type:    'image',
							options: { hotspot: true },
							fields:  [
								{
									name:  'alt',
									type:  'string',
									title: 'Alt text',
								},
							],
						},
					],
				},
				{
					name:  'th',
					title: 'Thai',
					type:  'array',
					of:    [
						{ type: 'block' },
						{
							type:    'image',
							options: { hotspot: true },
							fields:  [
								{
									name:  'alt',
									type:  'string',
									title: 'Alt text',
								},
							],
						},
					],
				},
			],
		}),
	],

	preview: {
		select: {
			title: 'seoTitle',
			slug:  'slug.current',
		},
		prepare({ title, slug }) {
			return {
				title,
				subtitle: `/${slug}`,
			};
		},
	},
});